import { InitialState } from '../state';
import { AppReducer } from './app-reducer';

export const manageDeviceProfilesReducer: AppReducer<'ManageDeviceProfiles'> = (
    state = InitialState.ManageAlarms,
    action
): typeof state => {
    switch (action.type) {
        case 'DeviceProfile/Save/Succeeded':
            return {
                ...state,
                loading: false,
                success: true,
            };
        case 'DeviceProfile/Save/Started':
            return {
                ...state,
                loading: true,
                success: false,
            };
        case 'DeviceProfile/Save/Unmounted':
            return {
                ...state,
                loading: false,
                success: false,
            };
        case 'DeviceProfile/Save/Reset':
            return {
                ...state,
                loading: false,
                success: false,
            };
        case 'DeviceProfile/Save/Failed':
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload.errorCode,
            };
        case 'DeviceProfile/SetSelectedDeviceProfileId':
            return {
                ...state,
                selectedDeviceProfile: action.payload.deviceProfileId,
                loading: false,
                success: false,
                error: '',
            };
        default:
            return state;
    }
};
